import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
  baseURL: `${BASE}/api`,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jfk9_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // Token expired or invalid — clear and let route guards handle redirect
      // Don't auto-redirect to avoid loops
    }
    return Promise.reject(err);
  }
);

export const setToken = (token) => {
  if (token) localStorage.setItem("jfk9_token", token);
  else localStorage.removeItem("jfk9_token");
};

export const getToken = () => localStorage.getItem("jfk9_token");
